import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import './App.css';

// Public Pages
import Home from './pages/Home';
import AppointmentBooking from './pages/AppointmentBooking';
import NewAppointmentBooking from './pages/NewAppointmentBooking';
import GrievanceSubmission from './pages/GrievanceSubmission';

// Service Details Page
import ServiceDetail from './pages/ServiceDetail/ServiceDetail';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminAppointments from './pages/admin/AdminAppointments';
import AdminGrievances from './pages/admin/AdminGrievances';
import AdminCenters from './pages/admin/AdminCenters';
import AdminServices from './pages/admin/AdminServices';
import AdminFees from './pages/admin/AdminFees';
import AdminAppointmentConfig from './pages/admin/AdminAppointmentConfig';
import AdminContent from './pages/admin/AdminContent';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';

// Booking Components
import BookingForm from './components/booking/BookingForm';
import OptionalServices from './pages/OptionalServices';
import TrackApplication from './pages/TrackApplication';
import FAQs from './pages/Faqs';
import AppointmentManagement from './pages/AppointmentManagement';
import ServiceCards from './components/ServiceCards';

// Protected Route
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  return token ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />

      <Routes>
        {/* ================= PUBLIC ROUTES ================= */}

        <Route path="/" element={<Home />} />

        <Route path="/appointments" element={<AppointmentBooking />} />

        <Route path="/appointments/new" element={<NewAppointmentBooking />} />

        <Route path="/optional-services" element={<OptionalServices />} />

        <Route path="/track-application" element={<TrackApplication />} />

        <Route path="/faqs" element={<FAQs />} />

        <Route path="/appointment-management" element={<AppointmentManagement />} />

       <Route path="/services/group/:serviceGroupId" element={<ServiceCards />} />



        <Route
          path="/appointments/booking-form"
          element={
            <div className="min-h-screen flex flex-col bg-secondary">
              <Header />
              <div className="flex-1 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                  <BookingForm />
                </div>
              </div>
              <Footer />
            </div>
          }
        />

        <Route path="/grievances" element={<GrievanceSubmission />} />

        {/* ✅ SERVICE DETAILS PAGE */}
        <Route
          path="/services/:serviceId"
          element={
            <div className="min-h-screen flex flex-col bg-secondary">
              <Header />
              <div className="flex-1">
                <ServiceDetail />
              </div>
              <Footer />
            </div>
          }
        />

        {/* ================= ADMIN ROUTES ================= */}

        <Route path="/admin/login" element={<AdminLogin />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/appointments"
          element={
            <ProtectedRoute>
              <AdminAppointments />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/grievances"
          element={
            <ProtectedRoute>
              <AdminGrievances />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/centers"
          element={
            <ProtectedRoute>
              <AdminCenters />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/services"
          element={
            <ProtectedRoute>
              <AdminServices />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/fees"
          element={
            <ProtectedRoute>
              <AdminFees />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/appointment-config"
          element={
            <ProtectedRoute>
              <AdminAppointmentConfig />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/content"
          element={
            <ProtectedRoute>
              <AdminContent />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;